import {
  Outlet,
  useLocation,
} from "react-router-dom";
import {
  useEffect,
  Suspense,
  useSyncExternalStore,
} from "react";

import EligibilityCheck from "./PriorAuthWorkFlow/containers/EligibilityCheck";
import { Loading } from "../components/custom/Loading/components/Loading";
import { NonIndexRouteWithFullPath } from "../models/Modules";
import { PatientDetails } from "./PatientDetails.ts";
import { AuthDetails } from "./AuthorizationDetails";
import UserManagement from "./UserManagement/containers/UserManagement";
import { forbiddenStore } from "../utils/forbiddenStore";
import UnAuthorizedPage from "../components/errorPages/401";
import ErrorPage from "../components/errorPages/404";
import { notFoundStore } from "../utils/notFoundStore";

export const Layout = () => {
  const location = useLocation();

  const isForbidden = useSyncExternalStore(
    forbiddenStore.subscribe,
    forbiddenStore.getSnapshot
  );
  const isNotFound = useSyncExternalStore(
    notFoundStore.subscribe,
    notFoundStore.getSnapshot
  );
  useEffect(() => {
    forbiddenStore.setForbidden(false);
    notFoundStore.setNotFound(false);
  }, [location.pathname]);

  if (isForbidden) {
    return <UnAuthorizedPage />;
  }
  if (isNotFound) {
    return <ErrorPage/>
  }
  return <Outlet />;
};

const RouteMapping: NonIndexRouteWithFullPath[] = [
  {
    path: "/",
    element: (
      <Suspense fallback={<Loading />}>
        <EligibilityCheck />
      </Suspense>
    ),
    children: [
      {
        path: "patient-details/:patientId",
        element: (
          <Suspense fallback={<Loading />}>
            <PatientDetails />
          </Suspense>
        ),
      },
      {
        path: "authorization-details/:authNo",
        element: (
          <Suspense fallback={<Loading />}>
            <AuthDetails />
          </Suspense>
        ),
      },
      {
        path: "user-management",
        element: (
          <Suspense fallback={<Loading />}>
            <UserManagement />
          </Suspense>
        ),
      },
    ],
  },
];

export default RouteMapping;
